import { packageStatuses, packageType } from 'shared/helpers/constants/packages/packageType';

const acceptInactiveSamplePkgForProcessingAccess = packagesList =>
  !packagesList?.packagesList?.incoming?.docs.some(
    p => p.packageType === packageType.sample && p.status !== packageStatuses.inactive,
  );

export { acceptInactiveSamplePkgForProcessingAccess };
